module.exports = __webpack_public_path__ + "img/preview_bg.49ed0b62.png";